import { useEffect, useState } from "react";
import { fetchGallerySections, type GallerySection } from "../api/contentful";

export function useGallerySections() {
  const [data, setData] = useState<GallerySection[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchGallerySections()
      .then(setData)
      .catch((err) =>
        setError(err instanceof Error ? err.message : "Failed to load gallery"),
      )
      .finally(() => setLoading(false));
  }, []);

  return { data, loading, error };
}
